module.exports = __webpack_public_path__ + "static/media/billiard.a1edb1f9.svg";